import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';
import { colors } from '@naf-simba/theme';

export const Main = styled.main`
  background: white;
`;

export const FullWidthSection = styled.div`
  background-color: ${colors.secondary[100]};
  margin: auto;
  padding: 0 ${spacing.space48};

  @media (max-width: ${breakpoints.l}) {
    padding: ${spacing.space24};
  }
`;

export const SectionContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  max-width: ${breakpoints.xl};
  margin: auto;
  padding: ${spacing.space48} ${spacing.space48};
  flex-direction: column;
  row-gap: ${spacing.space120};

  @media (max-width: ${breakpoints.xl}) {
    padding-top: ${spacing.space48};
  }

  @media (max-width: ${breakpoints.l}) {
    padding: ${spacing.space24};
    row-gap: ${spacing.space48};
  }
`;

export const FeedbackContainer = styled.div`
  padding: 0 ${spacing.space48} ${spacing.space64} ${spacing.space48};
  margin: 0 auto;
  max-width: ${breakpoints.xl};
  box-sizing: border-box;
`;
